import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';
import { Controller } from 'react-hook-form';
import { RhfProps } from './types/RhfProps';
import { RhfStyleProps } from './types/RhfStyleProps';

type Props = RhfProps & RhfStyleProps & CheckboxProps;

/**
 * 等於 MUI.Checkbox (無文字標籤的)
 */
const RhfCheck = ({ rhf, name, defaultValue, rules,  // RhfProps
  sx, className, style,// RhfStyleProps
  ...restProps
}: Props) => {
  return (
    <Controller
      control={rhf?.control}
      name={name}
      defaultValue={(defaultValue == null ? false : defaultValue)}
      rules={rules}

      render={({ field: { onChange, value, ...field } }) => (
        <Checkbox
          {...restProps}
          sx={sx} className={className} style={style}

          {...field}
          onChange={(e, checked) => {
            onChange(e.target.checked);// RHF
            restProps.onChange?.(e, checked);// 自己設定的onChange
          }}
          checked={Boolean(value)}
        />
      )}
    />
  )
}


export default RhfCheck